import(/* webpackMode: "eager" */ "/Users/jacoblindelof/Projects/pcmi-monorepo/apps/go-high-level/src/app/global-error.tsx");
